module.exports = __webpack_public_path__ + "static/media/three_wise_monkeys_sculptures_set.6602e72e.png";